const WINES_PER_PAGE = 18;

export default WINES_PER_PAGE;
